import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { formatDate, relativeTime } from "../lib/format";
import { CheckCheck, RefreshCw } from "lucide-react";

export default function Alerts() {
  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [unreadOnly, setUnreadOnly] = useState(false);
  const [refreshing, setRefreshing] = useState(false);

  const load = async () => {
    setLoading(true);
    const { data } = await api.get("/alerts", { params: { unread_only: unreadOnly, limit: 200 } });
    setAlerts(data);
    setLoading(false);
  };
  useEffect(() => { load(); }, [unreadOnly]);

  const refresh = async () => {
    setRefreshing(true);
    await api.post("/alerts/refresh");
    await load();
    setRefreshing(false);
  };

  const readAll = async () => {
    await api.post("/alerts/read-all");
    await load();
  };

  const markRead = async (id) => {
    await api.post(`/alerts/${id}/read`);
    setAlerts(alerts.map((a) => a.id === id ? { ...a, read: true } : a));
  };

  return (
    <div data-testid="alerts-page">
      <div className="flex items-end justify-between mb-6">
        <div>
          <div className="label-meta">Notifications</div>
          <div className="display">Alerts</div>
          <p className="text-[13px] mt-1" style={{ color: "var(--parapet-text-secondary)" }}>
            Alerts are generated when a real opportunity scores at or above your profile threshold.
          </p>
        </div>
        <div className="flex gap-2">
          <button className="btn-secondary" onClick={refresh} disabled={refreshing} data-testid="alerts-refresh-button">
            <RefreshCw size={14} className={"inline mr-1" + (refreshing ? " animate-spin" : "")} /> Refresh
          </button>
          <button className="btn-ghost" onClick={readAll} data-testid="alerts-read-all">
            <CheckCheck size={14} className="inline mr-1" /> Mark all read
          </button>
        </div>
      </div>

      <div className="flex items-center gap-2 mb-4">
        <button className={"filter-chip" + (!unreadOnly ? " active" : "")} onClick={() => setUnreadOnly(false)}>All</button>
        <button className={"filter-chip" + (unreadOnly ? " active" : "")} onClick={() => setUnreadOnly(true)}>Unread only</button>
      </div>

      <div className="p-card" style={{ padding: 0 }}>
        {loading ? <div className="p-6 text-center"><span className="spinner" /></div> :
          alerts.length === 0 ? <div className="empty-state m-6"><h3>No alerts</h3><p>Click "Refresh" or lower your profile threshold to receive matches.</p></div> : (
          <div>
            {alerts.map((a) => (
              <div key={a.id} className="flex items-start gap-3 px-4 py-3 border-b last:border-0" style={{ borderColor: "var(--parapet-grid)", background: a.read ? "transparent" : "var(--parapet-surface)" }} data-testid={`alert-row-${a.id}`}>
                <div className="flex-1">
                  <div className="text-[13px] font-medium">{a.title}</div>
                  <div className="text-[13px]" style={{ color: "var(--parapet-text-secondary)" }}>{a.body}</div>
                  <div className="text-[11px] mt-1" style={{ color: "var(--parapet-text-secondary)" }}>{relativeTime(a.created_at)}</div>
                </div>
                <div className="flex items-center gap-2">
                  {a.notice_id && <Link to={`/app/opportunities/${a.notice_id}`} className="btn-ghost text-[12px]">View →</Link>}
                  {!a.read && <button onClick={() => markRead(a.id)} className="btn-ghost text-[12px]">Mark read</button>}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
